let meta = document.head.querySelector('meta[name="csrf-token"]');
let csrf = null;
if (!meta || meta.content.replace(/ /g, "") === "{{csrf_token()}}") {
  // Local development
} else if (meta) {
  csrf = meta.content;
} else {
  console.error("CSRF token not found!");
}

export const csrfTokenInput = `<input class="d-none" type="hidden" name="_token" value="${csrf}" />`;

export default csrf;
